import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

const RoleRoute = ({ roles, children }) => {
  const { hasRole } = useContext(AuthContext);
  
  // Always check localStorage directly first for user role
  const userJson = localStorage.getItem('user');
  let manualRoleCheck = false;
  let userRole = null;
  
  // Log what we're looking for
  console.log('RoleRoute: Checking for roles:', roles);
  
  if (userJson) {
    try {
      const userData = JSON.parse(userJson);
      userRole = userData.role;
      console.log('RoleRoute: Found user in localStorage with role:', userRole);
      manualRoleCheck = roles.includes(userRole);
      console.log('RoleRoute: Manual role check result:', manualRoleCheck);
    } catch (e) {
      console.error('RoleRoute: Error checking user role from localStorage:', e);
    }
  } else {
    console.log('RoleRoute: No user found in localStorage');
  }
  
  // Also try token for additional verification
  const token = localStorage.getItem('token');
  console.log('RoleRoute: Token exists in localStorage:', !!token);

  // If we have a token and valid role check, allow access
  if (manualRoleCheck && token) {
    console.log('RoleRoute: Access granted via localStorage role check + token');
    return children;
  }
  
  // Fall back to context check
  if (hasRole(roles)) {
    console.log('RoleRoute: Access granted via context role check');
    return children;
  }
  
  // If both checks fail, deny access
  console.log('RoleRoute: Access denied - no valid role found');
  console.log('RoleRoute: User does not have required role, redirecting to dashboard');
  
  // If user doesn't have required role, redirect to dashboard
  return <Navigate to="/" replace />;
};

export default RoleRoute;